import { Form } from 'antd';
import React from 'react';

import { LIST_GROUP_PHASE, LIST_PHASE } from '../const';
import { IFieldBase } from '../interfaces';
import ListItem from '../outListItem';
import { ItemType } from '../types';
import { ParentRefType } from './ListItem/CommonLoaderListItem';

export interface IFieldPhase<T> extends IFieldBase {
    required?: boolean;
    parentRef?: React.RefObject<ParentRefType>;
    name?: keyof T;
}

const FieldPhase = React.forwardRef(
    <T extends Record<string, any>>(
        { required, parentRef, name, ...restProps }: IFieldPhase<T>,
        ref: React.Ref<any>,
    ) => {
        return (
            <Form.Item<ItemType>
                label="Phase"
                name={name as any}
                rules={[{ required: required, message: 'Please select phase!' }]}
            >
                <ListItem
                    nameList={LIST_PHASE}
                    parentRef={parentRef}
                    parentNameList={LIST_GROUP_PHASE}
                    readonly
                    {...restProps}
                    ref={ref}
                />
            </Form.Item>
        );
    },
) as <T extends Record<string, any>>(props: IFieldPhase<T> & { ref?: React.Ref<any> }) => React.JSX.Element;

export default FieldPhase;
